import { render, staticRenderFns } from "./PresenceValidation.vue?vue&type=template&id=86438444&"
import script from "./PresenceValidation.vue?vue&type=script&lang=js&"
export * from "./PresenceValidation.vue?vue&type=script&lang=js&"
import style0 from "./PresenceValidation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports